export default [
  {
    path: "codigos",
    name: "erp-codes",
    redirect: { name: "erp-codes-list" },
    children: [
      {
        path: "",
        name: "erp-codes-list",
        component: () => import("@/modules/erpCodes/views/CodesList.vue"),
      },

    ],
  },
];
